import { makeStyles } from "@material-ui/core";
import { Grid, Typography } from "@mui/material";
import { useState } from "react";
import { ThemeContext } from "../../theme/ThemeContext";

import OffenderDialog from "./OffenderDialog";
import { useContext } from "react";

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: "20px",
    minWidth: "900px",
    marginLeft: "50px",
  },
}));

function Offender(props) {
  const [open, setOpen] = useState(props.open);
  const classes = useStyles();
  const handleClose = () => {
    props.handleCloseMatch(false);
  };
  const { darkMode } = useContext(ThemeContext);
  const textColor = darkMode ? "#FFFFFF" : "#000000";
  const visitorBg = darkMode ? "#1E2A3A" : "#EFEFEF";
  const offenderBg = darkMode ? "#5C2B2B" : "#FFCCCB";
  //   const handleDate = (data) => {
  //     let date = data.split("T")[0];
  //     return date;
  //   };
  return (
    <OffenderDialog
      Header={"Possible Offender Records"}
      acceptText={"Match"}
      cancelText={"Unmatch"}
      open={open}
      onSubmit={() => {
        props.handleMatch();
      }}
      onClose={() => {
        props.handleCloseMatch();
        setOpen(!open);
      }}
    >
      <Grid container padding={3} className={classes.dialogBox}>
        <Grid
          container
          padding={2}
          spacing={2}
          xs={12}
          sm={12}
          md={6}
          lg={6}
          xl={6}
        >
          <Grid
            item
            style={{ border: "2px solid grey", backgroundColor: visitorBg }}
          >
            <Grid
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignContent: "center",
                alignItems: "center",
              }}
            >
              <Typography variant="h3" style={{ color: textColor }}>
                Visitor
              </Typography>
            </Grid>

            <Grid
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignContent: "center",
                alignItems: "center",
              }}
              padding={2}
            >
              <img
                src={props.visitorDLImage ? props.visitorDLImage : ""}
                height={"100px"}
                width={"100px"}
              />
            </Grid>

            <Grid container spacing={2} padding={2}>
              <Grid
                item
                sx={12}
                sm={12}
                md={6}
                lg={6}
                xl={6}
                style={{
                  fontWeight: "bold",
                  fontSize: "larger",
                  color: textColor,
                }}
              >
                First Name
              </Grid>

              <Grid
                item
                sx={12}
                sm={12}
                md={6}
                lg={6}
                xl={6}
                style={{ fontSize: "larger", color: textColor }}
              >
                {props.visitorDLData.firstName}
              </Grid>
              <Grid
                item
                sx={12}
                sm={12}
                md={6}
                lg={6}
                xl={6}
                style={{
                  fontWeight: "bold",
                  fontSize: "larger",
                  color: textColor,
                }}
              >
                Last Name
              </Grid>

              <Grid
                item
                sx={12}
                sm={12}
                md={6}
                lg={6}
                xl={6}
                style={{ fontSize: "larger", color: textColor }}
              >
                {props.visitorDLData.lastName}
              </Grid>
              <Grid
                item
                sx={12}
                sm={12}
                md={6}
                lg={6}
                xl={6}
                style={{
                  fontWeight: "bold",
                  fontSize: "larger",
                  color: textColor,
                }}
              >
                DOB
              </Grid>

              <Grid
                item
                sx={12}
                sm={12}
                md={6}
                lg={6}
                xl={6}
                style={{ fontSize: "larger", color: textColor }}
              >
                {/* {handleDate(props.visitorDLData.dob)} */}
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid
          container
          padding={2}
          spacing={2}
          xs={12}
          sm={12}
          md={6}
          lg={6}
          xl={6}
        >
          <Grid
            item
            style={{ border: "2px solid grey", backgroundColor: offenderBg }}
          >
            <Grid
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignContent: "center",
                alignItems: "center",
              }}
            >
              <Typography variant="h3" style={{ color: textColor }}>
                Offender
              </Typography>
            </Grid>

            <Grid
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignContent: "center",
                alignItems: "center",
              }}
              padding={2}
            >
              <img
                src={
                  props.data.offenderImageUrlR2
                    ? props.data.offenderImageUrlR2
                    : props.data.offenderImageUrl
                }
                alt="no Image"
                height={"100px"}
                width={"100px"}
              />
            </Grid>

            <Grid container spacing={2} padding={2}>
              <Grid
                item
                sx={12}
                sm={12}
                md={6}
                lg={6}
                xl={6}
                style={{
                  fontWeight: "bold",
                  fontSize: "larger",
                  color: textColor,
                }}
              >
                First Name
              </Grid>

              <Grid
                item
                sx={12}
                sm={12}
                md={6}
                lg={6}
                xl={6}
                style={{ fontSize: "larger", color: textColor }}
              >
                {props.data.firstName}
              </Grid>
              <Grid
                item
                sx={12}
                sm={12}
                md={6}
                lg={6}
                xl={6}
                style={{
                  fontWeight: "bold",
                  fontSize: "larger",
                  color: textColor,
                }}
              >
                Last Name
              </Grid>

              <Grid
                item
                sx={12}
                sm={12}
                md={6}
                lg={6}
                xl={6}
                style={{ fontSize: "larger", color: textColor }}
              >
                {props.data.lastName}
              </Grid>
              <Grid
                item
                sx={12}
                sm={12}
                md={6}
                lg={6}
                xl={6}
                style={{
                  fontWeight: "bold",
                  fontSize: "larger",
                  color: textColor,
                }}
              >
                DOB
              </Grid>

              <Grid
                item
                sx={12}
                sm={12}
                md={6}
                lg={6}
                xl={6}
                style={{ fontSize: "larger", color: textColor }}
              >
                {/* {handleDate(props.data.dob)} */}
              </Grid>
              <Grid
                item
                sx={12}
                sm={12}
                md={6}
                lg={6}
                xl={6}
                style={{
                  fontWeight: "bold",
                  fontSize: "larger",
                  color: textColor,
                }}
              >
                Gender
              </Grid>

              <Grid
                item
                sx={12}
                sm={12}
                md={6}
                lg={6}
                xl={6}
                style={{ fontSize: "larger", color: textColor }}
              >
                {props.data.sex}
              </Grid>
              <Grid
                item
                sx={12}
                sm={12}
                md={6}
                lg={6}
                xl={6}
                style={{
                  fontWeight: "bold",
                  fontSize: "larger",
                  color: textColor,
                }}
              >
                Eye Colour
              </Grid>

              <Grid
                item
                sx={12}
                sm={12}
                md={6}
                lg={6}
                xl={6}
                style={{ fontSize: "larger", color: textColor }}
              >
                {props.data.eyeColor}
              </Grid>
              <Grid
                item
                sx={12}
                sm={12}
                md={6}
                lg={6}
                xl={6}
                style={{
                  fontWeight: "bold",
                  fontSize: "larger",
                  color: textColor,
                }}
              >
                Height
              </Grid>

              <Grid
                item
                sx={12}
                sm={12}
                md={6}
                lg={6}
                xl={6}
                style={{ fontSize: "larger", color: textColor }}
              >
                {props.data.height}
              </Grid>
              <Grid
                item
                sx={12}
                sm={12}
                md={6}
                lg={6}
                xl={6}
                style={{
                  fontWeight: "bold",
                  fontSize: "larger",
                  color: textColor,
                }}
              >
                Weight
              </Grid>

              <Grid
                item
                sx={12}
                sm={12}
                md={6}
                lg={6}
                xl={6}
                style={{ fontSize: "larger", color: textColor }}
              >
                {props.data.weight}
              </Grid>
              <Grid
                item
                sx={12}
                sm={12}
                md={6}
                lg={6}
                xl={6}
                style={{
                  fontWeight: "bold",
                  fontSize: "larger",
                  color: textColor,
                }}
              >
                Street
              </Grid>

              <Grid
                item
                sx={12}
                sm={12}
                md={6}
                lg={6}
                xl={6}
                style={{ fontSize: "larger", color: textColor }}
              ></Grid>
              <Grid
                item
                sx={12}
                sm={12}
                md={6}
                lg={6}
                xl={6}
                style={{
                  fontWeight: "bold",
                  fontSize: "larger",
                  color: textColor,
                }}
              >
                State
              </Grid>

              <Grid
                item
                sx={12}
                sm={12}
                md={6}
                lg={6}
                xl={6}
                style={{ fontSize: "larger", color: textColor }}
              >
                {props.data.state}
              </Grid>
              <Grid
                item
                sx={12}
                sm={12}
                md={6}
                lg={6}
                xl={6}
                style={{
                  fontWeight: "bold",
                  fontSize: "larger",
                  color: textColor,
                }}
              >
                Zipcode
              </Grid>

              <Grid
                item
                sx={12}
                sm={12}
                md={6}
                lg={6}
                xl={6}
                style={{ fontSize: "larger", color: textColor }}
              >
                {props.data.zipcode}
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          style={{ color: "#E3393C", fontWeight: "bold", fontSize: "larger" }}
        >
          Offence
        </Grid>
        <Grid style={{ color: textColor }}>{props.data.crime}</Grid>
      </Grid>
    </OffenderDialog>
  );
}

export default Offender;
